import type { LocationQuery } from 'vue-router'

const dayjs = useDayjs()

/**
 * 타임스탬프 값을 문자열로 변경
 * - milliseconds 아님 주의
 *
 * @param seconds timestamp seconds
 */
const dateFormat = (seconds: number) => {
  return dayjs(seconds * 1000).format('YYYY.MM.DD')
}

const makeParamByQueryString = (
  query: LocationQuery
): { [key: string]: string | number } => {
  const rv: { [key: string]: string | number } = {}
  Object.keys(query).forEach((key: string) => {
    rv[key] =
      typeof query[key] === 'number' ? Number(query[key]) : String(query[key])
  })
  return rv
}

const capitalizeFirstLetter = (str: string) =>
  str ? str[0].toUpperCase() + str.slice(1) : ''

/**
 * DOM에 전달받은 클래스를 추가한다.
 * @param {Element} dom - DOM 객체
 * @param {String} className - 클래스 이름
 */
const addClass = (dom: HTMLElement | Array<HTMLElement>, className: string) => {
  if (dom && className.length) {
    const _dom = Array.isArray(dom) ? dom : [dom]
    _dom.forEach((el) => {
      el.classList.add(className)
    })
  }
}
/**
 * DOM에 전달 받은 클래스를 제거한다.
 * @param {Element} dom - DOM 객체
 * @param {String} className - 클래스 이름
 */
const removeClass = (
  dom: HTMLElement | Array<HTMLElement>,
  className: string
) => {
  if (dom && className.length) {
    const _dom = Array.isArray(dom) ? dom : [dom]
    _dom.forEach((el) => {
      el.classList.remove(className)
    })
  }
}

const checkDiffTime = (params: {
  base?: number
  another?: number
  value?: number
  unit?: any
}) => {
  const { base = dayjs(), another = dayjs(), value = 1, unit = 'd' } = params
  const baseDate = dayjs(base).startOf(unit)
  const anotherDate = dayjs(another).startOf(unit)
  const result = baseDate.diff(anotherDate, unit)

  return result >= value // 단순 날짜 차이 계산
}

function doDownloadClient(callback: Function) {
  const { $customDevice, $toast, $i18n } = useNuxtApp()
  if ($customDevice.isMobileOrTablet) {
    checkWebPlayPossible(() =>
      $toast.warning($i18n.t('webClient_4'), {
        toastId: 'download-mo'
      })
    )
  } else {
    window.open(useRuntimeConfig().public.clientDownloadURL, '_blank')
    if (typeof callback === 'function') {
      callback()
    }
  }
}
function checkWebPlayPossible(callback?: Function) {
  const { $customDevice, $toast, $i18n } = useNuxtApp()
  if ($customDevice.isMobile) {
    $toast.warning($i18n.t('webClient_5'), {
      toastId: 'play-mo'
    })
    return false
  }
  if (typeof callback === 'function') {
    callback()
  }
}
const downloadBinaryFile = async ({
  blob,
  fileName
}: {
  blob: Blob
  fileName: string
}) => {
  const blobUrl = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  // 메모리 누수 방지를 위해 요소/URL 정리
  document.body.removeChild(link)
  URL.revokeObjectURL(blobUrl)
}

export {
  checkDiffTime,
  doDownloadClient,
  checkWebPlayPossible,
  downloadBinaryFile,
  dateFormat,
  makeParamByQueryString,
  capitalizeFirstLetter,
  addClass,
  removeClass
}
